import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { AdministratorsFacade } from 'mbs-ui-shared/src/lib/facades/administrators.facade';
import {
  ProfilePostActions,
  RmmAlertingGeneralAlerts,
  RmmAlertingWindowsAlerts,
  RMMAlertTypes
} from 'mbs-ui-shared@models/rmm-custom-notification-model';
import * as ScriptLibraryActions from 'mbs-ui-shared@store/rmmScriptLibrary/actions';
import { debounceTime, filter, switchMap, take, tap } from 'rxjs';
import { LoadRmmCustomNotificationWizardService } from '../../utility/load-rmm-custom-notification-wizard.service';

@UntilDestroy()
@Component({
  selector: 'mbs-profile-notification-settings-action',
  templateUrl: './profile-notification-settings.component.html'
})
export class ProfileNotificationSettingsAction {
  public isUnifiedSetup = true;
  public includeConnectWise = false;
  public loading = true;

  public postActions: ProfilePostActions = null;
  public unifiedPostActions: ProfilePostActions = null;
  public perAlertPostActions: ProfilePostActions = null;
  public noEnabledAlerts = false;
  public alerts: RMMAlertTypes[] = RmmAlertingGeneralAlerts.concat(RmmAlertingWindowsAlerts);
  private readonly commonKey = 'general';

  constructor(
    private adminFacade: AdministratorsFacade,
    private store: Store,
    private loadRmmCustomNotificationWizardService: LoadRmmCustomNotificationWizardService
  ) {
    this.loading = true;
    this.adminFacade.loadData();
    this.store.dispatch(ScriptLibraryActions.loadScriptsInLibrary());
    this.includeConnectWise = this.loadRmmCustomNotificationWizardService.showConnectWise;

    this.loadRmmCustomNotificationWizardService.notificationsToSave.pipe(untilDestroyed(this)).subscribe((value) => {
      this.noEnabledAlerts = !this.alerts.some((key) => value && key in value && value[key]?.enabled);
    });

    this.loadRmmCustomNotificationWizardService.onPostActionsReLoaded
      .pipe(
        debounceTime(300),
        filter((value) => value),
        tap(() => this.loadRmmCustomNotificationWizardService.onPostActionsReLoaded.next(false)),
        switchMap((value) => this.loadRmmCustomNotificationWizardService.profileActionPayload.pipe(take(1))),
        untilDestroyed(this)
      )
      .subscribe((value) => {
        this.isUnifiedSetup = !!(value && this.commonKey in value && value[this.commonKey]?.recipient);
        this.postActions = cloneDeep(value);
        this.loading = false;
      });
  }

  setUnifiedMode(unified: boolean) {
    unified
      ? (this.perAlertPostActions = cloneDeep(this.loadRmmCustomNotificationWizardService.profileActionPayload.getValue()))
      : (this.unifiedPostActions = cloneDeep(this.loadRmmCustomNotificationWizardService.profileActionPayload.getValue()));

    this.setupPostActionSend(unified);

    this.isUnifiedSetup = unified;
  }

  setupPostActionSend(unified: boolean) {
    if (unified) {
      if (this.unifiedPostActions) this.postActions = cloneDeep(this.unifiedPostActions);
    } else {
      if (this.perAlertPostActions) this.postActions = cloneDeep(this.perAlertPostActions ?? this.unifiedPostActions);
    }

    this.loadRmmCustomNotificationWizardService.profileActionPayload.next(cloneDeep(this.postActions));
  }
}
